
export const DocumentAdapter = (document: any, listCategories: any[]) => {
    const obj = {...document};
    const filteredArray = listCategories?.filter((item: any) => obj?.categorieLavoratori?.includes(Number(item.value)));
    obj.categorieLavoratori = filteredArray;
    return obj;
}

export const DocumentAdapterToServer = (document: DocumentToServer) => {
    const obj = {...document};
    obj.categorieLavoratori = document.categorieLavoratori.map((cat: {value: string, label: string}) => Number(cat.value));
    return obj;
}

export type DocumentToServer = {
    id?: number;
    nome: string;
    descrizione: string;
    categorieLavoratori: number[]  | {value: string, label: string}[] | any ;
    document?: File[]
}